(() => {
class ShopifyFormStyler {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => this.init());
  }

  init() {
    this.observer = new MutationObserver(() => this.applyStyles());
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  applyStyles() {
    const formEmbed = document.querySelector("form-embed");
    if (!formEmbed || !formEmbed.shadowRoot) return;

    /** 🎯 Submit Button Styling **/
    this.styleSubmitButton(formEmbed);

    /** 🎯 Radio Label Styling **/
    this.styleRadioLabels(formEmbed);

    /** 🎯 Fieldset Margin **/
    this.styleFieldset(formEmbed);

    /** 🎯 Horizontal Layout Flexbox **/
    this.styleHorizontalLayout(formEmbed);

    /** ✅ Stop observer once elements are styled **/
    this.observer.disconnect();
  }

  styleSubmitButton(formEmbed) {
    const button = formEmbed.shadowRoot.querySelector("button._formSubmitButton_cit2d_96");
    if (button) {
      Object.assign(button.style, {
        width: "100%",
        maxWidth: "200px",
        margin: "40px auto 0 auto",
        textTransform: "uppercase",
        fontSize: "16px",
      });
    }
  }

  styleRadioLabels(formEmbed) {
    const labels = formEmbed.shadowRoot.querySelectorAll("fieldset label");
    if (!labels.length) return;

    labels.forEach(label => {
      Object.assign(label.style, {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 20px",
        margin: "5px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        backgroundColor: "#fff",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        transition: "all 0.2s ease",
      });

      const input = label.querySelector("input[type=radio]");
      if (input) {
        input.addEventListener("change", () => {
          labels.forEach(l => {
            l.style.borderColor = "#ccc";
            l.style.backgroundColor = "#fff";
          });
          if (input.checked) {
            label.style.borderColor = "#000";
            label.style.backgroundColor = "#f5f5f5";
          }
        });
      }
    });
  }

  styleFieldset(formEmbed) {
    const fieldset = formEmbed.shadowRoot.querySelector("form._formFieldset_cit2d_82");
    if (fieldset) {
      fieldset.style.marginTop = "30px";
    }
  }

  styleHorizontalLayout(formEmbed) {
    const horizontalLayout = formEmbed.shadowRoot.querySelector("._horizontalLayout_nw6va_12");
    if (horizontalLayout) {
      Object.assign(horizontalLayout.style, {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "0px",
      });
    }
  }
}

// 🚀 Initialize
new ShopifyFormStyler();

})();